// removed by extract-text-webpack-plugin
module.exports = {"font-header":"Divider-module__font-header__OKO8C","fontHeader":"Divider-module__font-header__OKO8C","font-primary":"Divider-module__font-primary__2mhXg","fontPrimary":"Divider-module__font-primary__2mhXg","font-secondary":"Divider-module__font-secondary__3jc0-","fontSecondary":"Divider-module__font-secondary__3jc0-","sr-only":"Divider-module__sr-only__2v0-3","srOnly":"Divider-module__sr-only__2v0-3","sr-only-important":"Divider-module__sr-only-important__2V7uf","srOnlyImportant":"Divider-module__sr-only-important__2V7uf","divider":"Divider-module__divider__2j-bl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Onboarding/Shared/Divider/Divider.module.scss
// module id = 658
// module chunks = 0